import { Component, OnInit, Input } from '@angular/core';
import { Formulario, Persona } from 'src/app/models';
import { RelacionFamiliar } from '../../../models/enums/relacionFamiliar';

@Component({
    selector: 'app-consulta-gf',
    templateUrl: 'grupo-familiar.component.html',
    styleUrls: ['grupo-familiar.component.scss']
})
export class ConsultaGFComponent implements OnInit {
    @Input() formulario: Formulario;

    objTitular: Persona;
    objConyuge: Persona;
    existeConyuge = false;
    CargaFamiliar: Array<Persona> = [];

    constructor() { }

    ngOnInit() {
      this.objTitular = this.formulario.ListaPersonas.filter(x => x.RelacionPersona === RelacionFamiliar.POSTULANTE)[0];
      if (this.objTitular.EstadoCivil.toString() === '1' || this.objTitular.EstadoCivil.toString() === '5') {
        this.objConyuge = this.formulario.ListaPersonas.filter(x => x.RelacionPersona === RelacionFamiliar.CONYUGE)[0];
        this.existeConyuge = true;
      }
      this.CargaFamiliar = this.formulario.ListaPersonas
      .filter(x => x.RelacionPersona !== RelacionFamiliar.CONYUGE && x.RelacionPersona !== RelacionFamiliar.POSTULANTE );
    }

}
